import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SelectData } from '../type/input';

@Injectable({ providedIn: 'root' })
export class SharedService {

  private readonly _router = inject(Router);
  private readonly _http = inject(HttpClient);

  countryData_es: SelectData[] = [
    { value: 'AF', label: 'Afganistán' },
    { value: 'AL', label: 'Albania' },
    { value: 'DE', label: 'Alemania' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguila' },
    { value: 'AQ', label: 'Antártida' },
    { value: 'AG', label: 'Antigua y Barbuda' },
    { value: 'SA', label: 'Arabia Saudita' },
    { value: 'DZ', label: 'Argelia' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AM', label: 'Armenia' },
    { value: 'AW', label: 'Aruba' },
    { value: 'AU', label: 'Australia' },
    { value: 'AT', label: 'Austria' },
    { value: 'AZ', label: 'Azerbaiyán' },
    { value: 'BS', label: 'Bahamas' },
    { value: 'BH', label: 'Bahrein' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BE', label: 'Bélgica' },
    { value: 'BZ', label: 'Belice' },
    { value: 'BJ', label: 'Benín' },
    { value: 'BT', label: 'Bhután' },
    { value: 'BY', label: 'Bielorrusia' },
    { value: 'MM', label: 'Birmania' },
    { value: 'BO', label: 'Bolivia' },
    { value: 'BQ', label: 'Bonaire, San Eustaquio y Saba' },
    { value: 'BA', label: 'Bosnia y Herzegovina' },
    { value: 'BW', label: 'Botsuana' },
    { value: 'BR', label: 'Brasil' },
    { value: 'BN', label: 'Brunéi' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'CV', label: 'Cabo Verde' },
    { value: 'KH', label: 'Camboya' },
    { value: 'CM', label: 'Camerún' },
    { value: 'CA', label: 'Canadá' },
    { value: 'TD', label: 'Chad' },
    { value: 'CL', label: 'Chile' },
    { value: 'CN', label: 'China' },
    { value: 'CY', label: 'Chipre' },
    { value: 'VA', label: 'Ciudad del Vaticano' },
    { value: 'CO', label: 'Colombia' },
    { value: 'KM', label: 'Comoras' },
    { value: 'KP', label: 'Corea del Norte' },
    { value: 'KR', label: 'Corea del Sur' },
    { value: 'CI', label: 'Costa de Marfil' },
    { value: 'CR', label: 'Costa Rica' },
    { value: 'HR', label: 'Croacia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'CW', label: 'Curazao' },
    { value: 'DK', label: 'Dinamarca' },
    { value: 'DM', label: 'Dominica' },
    { value: 'EC', label: 'Ecuador' },
    { value: 'EG', label: 'Egipto' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'AE', label: 'Emiratos Árabes Unidos' },
    { value: 'ER', label: 'Eritrea' },
    { value: 'SK', label: 'Eslovaquia' },
    { value: 'SI', label: 'Eslovenia' },
    { value: 'ES', label: 'España' },
    { value: 'US', label: 'Estados Unidos de América' },
    { value: 'EE', label: 'Estonia' },
    { value: 'ET', label: 'Etiopía' },
    { value: 'PH', label: 'Filipinas' },
    { value: 'FI', label: 'Finlandia' },
    { value: 'FJ', label: 'Fiyi' },
    { value: 'FR', label: 'Francia' },
    { value: 'GA', label: 'Gabón' },
    { value: 'GM', label: 'Gambia' },
    { value: 'GE', label: 'Georgia' },
    { value: 'GH', label: 'Ghana' },
    { value: 'GI', label: 'Gibraltar' },
    { value: 'GD', label: 'Granada' },
    { value: 'GR', label: 'Grecia' },
    { value: 'GL', label: 'Groenlandia' },
    { value: 'GP', label: 'Guadalupe' },
    { value: 'GU', label: 'Guam' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GF', label: 'Guayana Francesa' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GN', label: 'Guinea' },
    { value: 'GQ', label: 'Guinea Ecuatorial' },
    { value: 'GW', label: 'Guinea-Bissau' },
    { value: 'GY', label: 'Guyana' },
    { value: 'HT', label: 'Haití' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong kong' },
    { value: 'HU', label: 'Hungría' },
    { value: 'IN', label: 'India' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'IQ', label: 'Irak' },
    { value: 'IR', label: 'Irán' },
    { value: 'IE', label: 'Irlanda' },
    { value: 'BV', label: 'Isla Bouvet' },
    { value: 'IM', label: 'Isla de Man' },
    { value: 'CX', label: 'Isla de Navidad' },
    { value: 'NF', label: 'Isla Norfolk' },
    { value: 'IS', label: 'Islandia' },
    { value: 'BM', label: 'Islas Bermudas' },
    { value: 'KY', label: 'Islas Caimán' },
    { value: 'CC', label: 'Islas Cocos (Keeling)' },
    { value: 'CK', label: 'Islas Cook' },
    { value: 'AX', label: 'Islas de Åland' },
    { value: 'FO', label: 'Islas Feroe' },
    { value: 'GS', label: 'Islas Georgias del Sur y Sandwich del Sur' },
    { value: 'HM', label: 'Islas Heard y McDonald' },
    { value: 'MV', label: 'Islas Maldivas' },
    { value: 'FK', label: 'Islas Malvinas' },
    { value: 'MP', label: 'Islas Marianas del Norte' },
    { value: 'MH', label: 'Islas Marshall' },
    { value: 'PN', label: 'Islas Pitcairn' },
    { value: 'SB', label: 'Islas Salomón' },
    { value: 'TC', label: 'Islas Turcas y Caicos' },
    { value: 'UM', label: 'Islas Ultramarinas Menores de Estados Unidos' },
    { value: 'VG', label: 'Islas Vírgenes Británicas' },
    { value: 'VI', label: 'Islas Vírgenes de los Estados Unidos' },
    { value: 'IL', label: 'Israel' },
    { value: 'IT', label: 'Italia' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JP', label: 'Japón' },
    { value: 'JE', label: 'Jersey' },
    { value: 'JO', label: 'Jordania' },
    { value: 'KZ', label: 'Kazajistán' },
    { value: 'KE', label: 'Kenia' },
    { value: 'KG', label: 'Kirguistán' },
    { value: 'KI', label: 'Kiribati' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'LA', label: 'Laos' },
    { value: 'LS', label: 'Lesoto' },
    { value: 'LV', label: 'Letonia' },
    { value: 'LB', label: 'Líbano' },
    { value: 'LR', label: 'Liberia' },
    { value: 'LY', label: 'Libia' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Lituania' },
    { value: 'LU', label: 'Luxemburgo' },
    { value: 'MO', label: 'Macao' },
    { value: 'MK', label: 'Macedônia' },
    { value: 'MG', label: 'Madagascar' },
    { value: 'MY', label: 'Malasia' },
    { value: 'MW', label: 'Malawi' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'MA', label: 'Marruecos' },
    { value: 'MQ', label: 'Martinica' },
    { value: 'MU', label: 'Mauricio' },
    { value: 'MR', label: 'Mauritania' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'México' },
    { value: 'FM', label: 'Micronesia' },
    { value: 'MD', label: 'Moldavia' },
    { value: 'MC', label: 'Mónaco' },
    { value: 'MN', label: 'Mongolia' },
    { value: 'ME', label: 'Montenegro' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NI', label: 'Nicaragua' },
    { value: 'NE', label: 'Niger' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'NU', label: 'Niue' },
    { value: 'NO', label: 'Noruega' },
    { value: 'NC', label: 'Nueva Caledonia' },
    { value: 'NZ', label: 'Nueva Zelanda' },
    { value: 'OM', label: 'Omán' },
    { value: 'NL', label: 'Países Bajos' },
    { value: 'PK', label: 'Pakistán' },
    { value: 'PW', label: 'Palau' },
    { value: 'PS', label: 'Palestina' },
    { value: 'PA', label: 'Panamá' },
    { value: 'PG', label: 'Papúa Nueva Guinea' },
    { value: 'PY', label: 'Paraguay' },
    { value: 'PE', label: 'Perú' },
    { value: 'PF', label: 'Polinesia Francesa' },
    { value: 'PL', label: 'Polonia' },
    { value: 'PT', label: 'Portugal' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'QA', label: 'Qatar' },
    { value: 'GB', label: 'Reino Unido' },
    { value: 'CF', label: 'República Centroafricana' },
    { value: 'CZ', label: 'República Checa' },
    { value: 'SS', label: 'República de Sudán del Sur' },
    { value: 'CG', label: 'República del Congo' },
    { value: 'CD', label: 'República Democrática del Congo' },
    { value: 'DO', label: 'República Dominicana' },
    { value: 'RE', label: 'Reunión' },
    { value: 'RW', label: 'Ruanda' },
    { value: 'RO', label: 'Rumanía' },
    { value: 'RU', label: 'Rusia' },
    { value: 'EH', label: 'Sahara Occidental' },
    { value: 'WS', label: 'Samoa' },
    { value: 'AS', label: 'Samoa Americana' },
    { value: 'BL', label: 'San Bartolomé' },
    { value: 'KN', label: 'San Cristóbal y Nieves' },
    { value: 'SM', label: 'San Marino' },
    { value: 'MF', label: 'San Martín (Francia)' },
    { value: 'PM', label: 'San Pedro y Miquelón' },
    { value: 'VC', label: 'San Vicente y las Granadinas' },
    { value: 'SH', label: 'Santa Elena' },
    { value: 'LC', label: 'Santa Lucía' },
    { value: 'ST', label: 'Santo Tomé y Príncipe' },
    { value: 'SN', label: 'Senegal' },
    { value: 'RS', label: 'Serbia' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SL', label: 'Sierra Leona' },
    { value: 'SG', label: 'Singapur' },
    { value: 'SX', label: 'Sint Maarten' },
    { value: 'SY', label: 'Siria' },
    { value: 'SO', label: 'Somalia' },
    { value: 'LK', label: 'Sri lanka' },
    { value: 'ZA', label: 'Sudáfrica' },
    { value: 'SD', label: 'Sudán' },
    { value: 'SE', label: 'Suecia' },
    { value: 'CH', label: 'Suiza' },
    { value: 'SR', label: 'Surinám' },
    { value: 'SJ', label: 'Svalbard y Jan Mayen' },
    { value: 'SZ', label: 'Swazilandia' },
    { value: 'TH', label: 'Tailandia' },
    { value: 'TW', label: 'Taiwán' },
    { value: 'TZ', label: 'Tanzania' },
    { value: 'TJ', label: 'Tayikistán' },
    { value: 'IO', label: 'Territorio Británico del Océano Índico' },
    { value: 'TF', label: 'Territorios Australes y Antárticas Franceses' },
    { value: 'TL', label: 'Timor Oriental' },
    { value: 'TG', label: 'Togo' },
    { value: 'TK', label: 'Tokelau' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad y Tobago' },
    { value: 'TN', label: 'Tunez' },
    { value: 'TM', label: 'Turkmenistán' },
    { value: 'TR', label: 'Turquía' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'UA', label: 'Ucrania' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'UZ', label: 'Uzbekistán' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Vietnam' },
    { value: 'WF', label: 'Wallis y Futuna' },
    { value: 'YE', label: 'Yemen' },
    { value: 'DJ', label: 'Yibuti' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'ZW', label: 'Zimbabue' },
    { value: 'WW', label: 'Mundial' }
  ];

  countryData_en: SelectData[] = [
    { value: 'AF', label: 'Afghanistan' },
    { value: 'AL', label: 'Albania' },
    { value: 'DE', label: 'Germany' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguilla' },
    { value: 'AQ', label: 'Antarctica' },
    { value: 'AG', label: 'Antigua and Barbuda' },
    { value: 'SA', label: 'Saudi Arabia' },
    { value: 'DZ', label: 'Algeria' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AM', label: 'Armenia' },
    { value: 'AW', label: 'Aruba' },
    { value: 'AU', label: 'Australia' },
    { value: 'AT', label: 'Austria' },
    { value: 'AZ', label: 'Azerbaijan' },
    { value: 'BS', label: 'Bahamas' },
    { value: 'BH', label: 'Bahrain' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BE', label: 'Belgium' },
    { value: 'BZ', label: 'Belize' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BT', label: 'Bhutan' },
    { value: 'BY', label: 'Belarus' },
    { value: 'MM', label: 'Myanmar' },
    { value: 'BO', label: 'Bolivia' },
    { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
    { value: 'BA', label: 'Bosnia and Herzegovina' },
    { value: 'BW', label: 'Botswana' },
    { value: 'BR', label: 'Brazil' },
    { value: 'BN', label: 'Brunei Darussalam' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'CV', label: 'Cabo Verde' },
    { value: 'KH', label: 'Cambodia' },
    { value: 'CM', label: 'Cameroon' },
    { value: 'CA', label: 'Canada' },
    { value: 'TD', label: 'Chad' },
    { value: 'CL', label: 'Chile' },
    { value: 'CN', label: 'China' },
    { value: 'CY', label: 'Cyprus' },
    { value: 'VA', label: 'Holy See' },
    { value: 'CO', label: 'Colombia' },
    { value: 'KM', label: 'Comoros' },
    { value: 'KP', label: 'Korea (Democratic People\'s Republic of)' },
    { value: 'KR', label: 'Korea (Republic of)' },
    { value: 'CI', label: 'Côte d\'Ivoire' },
    { value: 'CR', label: 'Costa Rica' },
    { value: 'HR', label: 'Croatia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'CW', label: 'Curaçao' },
    { value: 'DK', label: 'Denmark' },
    { value: 'DM', label: 'Dominica' },
    { value: 'EC', label: 'Ecuador' },
    { value: 'EG', label: 'Egypt' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'AE', label: 'United Arab Emirates' },
    { value: 'ER', label: 'Eritrea' },
    { value: 'SK', label: 'Slovakia' },
    { value: 'SI', label: 'Slovenia' },
    { value: 'ES', label: 'Spain' },
    { value: 'US', label: 'United States of America' },
    { value: 'EE', label: 'Estonia' },
    { value: 'ET', label: 'Ethiopia' },
    { value: 'PH', label: 'Philippines' },
    { value: 'FI', label: 'Finland' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'FR', label: 'France' },
    { value: 'GA', label: 'Gabon' },
    { value: 'GM', label: 'Gambia' },
    { value: 'GE', label: 'Georgia' },
    { value: 'GH', label: 'Ghana' },
    { value: 'GI', label: 'Gibraltar' },
    { value: 'GD', label: 'Grenada' },
    { value: 'GR', label: 'Greece' },
    { value: 'GL', label: 'Greenland' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GF', label: 'French Guiana' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GN', label: 'Guinea' },
    { value: 'GQ', label: 'Equatorial Guinea' },
    { value: 'GW', label: 'Guinea-Bissau' },
    { value: 'GY', label: 'Guyana' },
    { value: 'HT', label: 'Haiti' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong Kong' },
    { value: 'HU', label: 'Hungary' },
    { value: 'IN', label: 'India' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'IQ', label: 'Iraq' },
    { value: 'IR', label: 'Iran' },
    { value: 'IE', label: 'Ireland' },
    { value: 'IS', label: 'Iceland' },
    { value: 'IT', label: 'Italy' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JP', label: 'Japan' },
    { value: 'JO', label: 'Jordan' },
    { value: 'KZ', label: 'Kazakhstan' },
    { value: 'KE', label: 'Kenya' },
    { value: 'KG', label: 'Kyrgyzstan' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'LA', label: 'Lao People\'s Democratic Republic' },
    { value: 'LV', label: 'Latvia' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'LS', label: 'Lesotho' },
    { value: 'LR', label: 'Liberia' },
    { value: 'LY', label: 'Libya' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'MO', label: 'Macao' },
    { value: 'MK', label: 'North Macedonia' },
    { value: 'MG', label: 'Madagascar' },
    { value: 'MY', label: 'Malaysia' },
    { value: 'MW', label: 'Malawi' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'MA', label: 'Morocco' },
    { value: 'MQ', label: 'Martinique' },
    { value: 'MU', label: 'Mauritius' },
    { value: 'MR', label: 'Mauritania' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'Mexico' },
    { value: 'FM', label: 'Micronesia (Federated States of)' },
    { value: 'MD', label: 'Moldova (the Republic of)' },
    { value: 'MC', label: 'Monaco' },
    { value: 'MN', label: 'Mongolia' },
    { value: 'ME', label: 'Montenegro' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NI', label: 'Nicaragua' },
    { value: 'NE', label: 'Niger (the)' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'NU', label: 'Niue' },
    { value: 'NO', label: 'Norway' },
    { value: 'NC', label: 'New Caledonia' },
    { value: 'NZ', label: 'New Zealand' },
    { value: 'OM', label: 'Oman' },
    { value: 'NL', label: 'Netherlands (the)' },
    { value: 'PK', label: 'Pakistan' },
    { value: 'PW', label: 'Palau' },
    { value: 'PS', label: 'Palestine, State of' },
    { value: 'PA', label: 'Panama' },
    { value: 'PG', label: 'Papua New Guinea' },
    { value: 'PY', label: 'Paraguay' },
    { value: 'PE', label: 'Peru' },
    { value: 'PF', label: 'French Polynesia' },
    { value: 'PL', label: 'Poland' },
    { value: 'PT', label: 'Portugal' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'QA', label: 'Qatar' },
    { value: 'GB', label: 'United Kingdom of Great Britain and Northern Ireland (the)' },
    { value: 'CF', label: 'Central African Republic (the)' },
    { value: 'CZ', label: 'Czechia' },
    { value: 'SS', label: 'South Sudan' },
    { value: 'CG', label: 'Congo (the)' },
    { value: 'CD', label: 'Congo (the Democratic Republic of the)' },
    { value: 'DO', label: 'Dominican Republic (the)' },
    { value: 'RE', label: 'Réunion' },
    { value: 'RW', label: 'Rwanda' },
    { value: 'RO', label: 'Romania' },
    { value: 'RU', label: 'Russian Federation (the)' },
    { value: 'EH', label: 'Western Sahara*' },
    { value: 'WS', label: 'Samoa' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'BL', label: 'Saint Barthélemy' },
    { value: 'KN', label: 'Saint Kitts and Nevis' },
    { value: 'SM', label: 'San Marino' },
    { value: 'MF', label: 'Saint Martin (French part)' },
    { value: 'PM', label: 'Saint Pierre and Miquelon' },
    { value: 'VC', label: 'Saint Vincent and the Grenadines' },
    { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
    { value: 'LC', label: 'Saint Lucia' },
    { value: 'ST', label: 'Sao Tome and Principe' },
    { value: 'SN', label: 'Senegal' },
    { value: 'RS', label: 'Serbia' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SL', label: 'Sierra Leone' },
    { value: 'SG', label: 'Singapore' },
    { value: 'SX', label: 'Sint Maarten (Dutch part)' },
    { value: 'SY', label: 'Syrian Arab Republic (the)' },
    { value: 'SO', label: 'Somalia' },
    { value: 'LK', label: 'Sri Lanka' },
    { value: 'ZA', label: 'South Africa' },
    { value: 'SD', label: 'Sudan (the)' },
    { value: 'SE', label: 'Sweden' },
    { value: 'CH', label: 'Switzerland' },
    { value: 'SR', label: 'Suriname' },
    { value: 'SJ', label: 'Svalbard and Jan Mayen' },
    { value: 'SZ', label: 'Eswatini' },
    { value: 'TH', label: 'Thailand' },
    { value: 'TW', label: 'Taiwan (Province of China)' },
    { value: 'TZ', label: 'Tanzania, the United Republic of' },
    { value: 'TJ', label: 'Tajikistan' },
    { value: 'IO', label: 'British Indian Ocean Territory (the)' },
    { value: 'TF', label: 'French Southern Territories (the)' },
    { value: 'TL', label: 'Timor-Leste' },
    { value: 'TG', label: 'Togo' },
    { value: 'TK', label: 'Tokelau' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad and Tobago' },
    { value: 'TN', label: 'Tunisia' },
    { value: 'TM', label: 'Turkmenistan' },
    { value: 'TR', label: 'Türkiye' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'UA', label: 'Ukraine' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'UZ', label: 'Uzbekistan' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VE', label: 'Venezuela (Bolivarian Republic of)' },
    { value: 'VN', label: 'Viet Nam' },
    { value: 'WF', label: 'Wallis and Futuna' },
    { value: 'YE', label: 'Yemen' },
    { value: 'DJ', label: 'Djibouti' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'ZW', label: 'Zimbabwe' },
    { value: 'WW', label: 'Mundial' }
  ];
  
  

  activityData: SelectData[] = [
    { value: 'empresa', label: 'registration-form-simple.company-type.client' },
    { value: 'broker', label: 'registration-form-simple.company-type.broker' },
    { value: 'otro', label: 'registration-form-simple.company-type.other' },
  ];

  langData: SelectData[] = [
    { value: 'es', label: 'Español' },
    { value: 'pt', label: 'Português' },
    { value: 'en', label: 'English' },
  ];

}